export const upper = value => value && value.toUpperCase();

export const state = value => value && value.toUpperCase().slice(0, 2);

export const lower = value => value && value.toLowerCase();

export const adLabel = value => value && value.slice(0, 20);

export const lessThan = otherField => (value, previousValue, allValues) =>
  (parseFloat(value) < parseFloat(allValues[otherField]) ? value : previousValue);

export const greaterThan = otherField => (value, previousValue, allValues) =>
  (parseFloat(value) > parseFloat(allValues[otherField]) ? value : previousValue);

export const onlyNum = value => value && value.replace(/[^\d]/g, '').trim();

export const upperTrimString = (value) => {
  const removeEmpty = value.replace(/\s/g, '');
  return removeEmpty.trim().toUpperCase();
};

export const lowerTrimString = (value) => {
  const removeEmpty = value.replace(/\s/g, '');
  const removeAccents = removeEmpty.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  return removeAccents.trim().toLowerCase();
};

export const crm = (value) => {
  const onlyNums = value.replace(/[^\d]/g, '');
  const onlyLetters = value.match(/[a-zA-Z]/g) ? value : '';

  if (onlyLetters.length <= 2) {
    return onlyLetters.toUpperCase().slice(0, 2);
  }

  if (onlyLetters.length >= 2) {
    return `${onlyLetters.toUpperCase().slice(0, 2)}${onlyNums.slice(0, 10)}`;
  }

  return '';
};

export const cep = (value) => {
  const onlyNums = value.replace(/[^\d]/g, '');

  if (onlyNums.length <= 5) {
    return onlyNums.slice(0, 5);
  }

  if (onlyNums.length > 5) {
    return `${onlyNums.slice(0, 5)}-${onlyNums.slice(5, 8)}`;
  }

  return false;
};

export const cpf = (value) => {
  const onlyNums = value.replace(/[^\d]/g, '');

  if (onlyNums.length < 3) {
    return onlyNums.slice(0, 3);
  }

  if (onlyNums.length <= 6) {
    return `${onlyNums.slice(0, 3)}.${onlyNums.slice(3, 6)}`;
  }

  if (onlyNums.length <= 9) {
    return `${onlyNums.slice(0, 3)}.${onlyNums.slice(3, 6)}.${onlyNums.slice(6, 9)}`;
  }

  if (onlyNums.length <= 11) {
    return `${onlyNums.slice(0, 3)}.${onlyNums.slice(3, 6)}.${onlyNums.slice(6, 9)}-${onlyNums.slice(9, 11)}`;
  }

  return false;
};

export const normalizePhone = (value) => {
  if (!value) {
    return value;
  }

  const onlyNums = value.replace(/[^\d]/g, '');

  if (onlyNums.length < 3) {
    return onlyNums.slice(0, 2);
  }

  if (onlyNums.length <= 6) {
    return `(${onlyNums.slice(0, 2)})${onlyNums.slice(2, 11)}`;
  }

  if (onlyNums.length <= 10) {
    return `(${onlyNums.slice(0, 2)})${onlyNums.slice(2, 6)}-${onlyNums.slice(6, 11)}`;
  }

  if (onlyNums.length === 11) {
    return `(${onlyNums.slice(0, 2)})${onlyNums.slice(2, 7)}-${onlyNums.slice(7, 11)}`;
  }

  return value;
};

